import React, {useState} from "react";
import {INTERVIEW_GAME as GAME} from "../../../common/utils/games";
import {GamePageState} from "../../../common/utils/pageState";
import {GameInfoComponent} from "../../../common/components/game-info/GameInfoComponent";
import InterviewGameConfig from "./components/InterviewGameConfig";
import InterviewGamePlay from "./components/InterviewGamePlay";
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import {IGameDescription, Localised, ProfessionType} from "../../../common/types";
import { usePageTitle } from "../../../common/hooks";
import {getCurrentLang} from "../../../common/utils/lang";

const gameDescription:Localised<IGameDescription> = require("./description.json");

const InterviewGamePage = () => {
    usePageTitle("games.interview.name");

    const [page, setPage] = useState<GamePageState>(GamePageState.INFO);
    const [professionTypes, setProfessionTypes] = useState<ProfessionType[]>([ProfessionType.REAL, ProfessionType.UNREAL]);

    const pageChangeClick = (targetState: GamePageState) => () => {
        setPage(targetState);
    };

    const activeLang = getCurrentLang();
    const infoPage = <GameInfoComponent game={GAME} description={gameDescription[activeLang]} nextClick={pageChangeClick(GamePageState.CONFIG)}/>;

    const configPage = <InterviewGameConfig
        onSetProfessions={setProfessionTypes}
        professionTypes={professionTypes}
        backToDetails={pageChangeClick(GamePageState.INFO)}
        nextToPlay={pageChangeClick(GamePageState.PLAY)}
    />;

    const playPage = <InterviewGamePlay professionTypes={professionTypes}
        showConfig={pageChangeClick(GamePageState.CONFIG)}
        showInfo={pageChangeClick(GamePageState.INFO)}
    />;

    const displayedPage = page === GamePageState.INFO ? infoPage : (page === GamePageState.CONFIG ? configPage : playPage);

    return (
        <PageContainer fixedHeaderFooter={true}>
            {displayedPage}
        </PageContainer>
    )
};

export default InterviewGamePage;
